import { r as D } from "../../../_virtual/react-input-mask.production.min.js";
import fe from "react";
import he from "react-dom";
import { __require as ge } from "../../prop-types/index.js";
import { __require as ve } from "../../invariant/browser.js";
import { __require as de } from "../../warning/warning.js";
var G;
function Se() {
  if (G)
    return D.exports;
  G = 1;
  function j(i) {
    return i && typeof i == "object" && "default" in i ? i.default : i;
  }
  var k = fe, F = j(k), J = he;
  ge();
  var q = j(ve());
  function V() {
    return (V = Object.assign || function(i) {
      for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t];
        for (var n in e)
          Object.prototype.hasOwnProperty.call(e, n) && (i[n] = e[n]);
      }
      return i;
    }).apply(this, arguments);
  }
  function K(i, t) {
    i.prototype = Object.create(t.prototype), i.prototype.constructor = i, function(e, n) {
      for (var r = Object.getOwnPropertyNames(n), a = 0; a < r.length; a++) {
        var l = r[a], s = Object.getOwnPropertyDescriptor(n, l);
        s && s.configurable && e[l] === void 0 && Object.defineProperty(e, l, s);
      }
    }(i, t);
  }
  function I(i, t) {
    if (i == null)
      return {};
    var e, n, r = {}, a = Object.keys(i);
    for (n = 0; n < a.length; n++)
      e = a[n], t.indexOf(e) >= 0 || (r[e] = i[e]);
    return r;
  }
  function B(i) {
    return requestAnimationFrame(i);
  }
  function N(i) {
    cancelAnimationFrame(i);
  }
  function O(i) {
    var t = i.ownerDocument;
    return t.hasFocus() && t.activeElement === i;
  }
  function T(i) {
    return i == null ? void 0 : i.ownerDocument;
  }
  function Q(i) {
    var t = function(e) {
      var n;
      return (n = T(e)) == null ? void 0 : n.defaultView;
    }(i);
    return !!t && i instanceof t.HTMLElement;
  }
  function M(i) {
    return k.useCallback(function() {
      var t = i.current, e = typeof window < "u" && Q(t);
      if (!t || !e)
        return null;
      if (t.nodeName !== "INPUT" && (t = t.querySelector("input")), !t)
        throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return t;
    }, [i]);
  }
  function ee(i, t) {
    var e, n, r, a, l = k.useRef({ start: null, end: null }), s = M(i), P = k.useCallback(function() {
      return function(g) {
        var f = g.selectionStart, S = g.selectionEnd;
        return { start: f, end: S, length: S - f };
      }(s());
    }, [s]), v = k.useCallback(function() {
      return l.current;
    }, []), u = k.useCallback(function(g) {
      var f = s();
      f && O(f) && (function(S, y, w) {
        w === void 0 && (w = y), S.setSelectionRange(y, w);
      }(f, g.start, g.end), l.current = P());
    }, [s, P]), o = k.useCallback(function() {
      l.current = P();
    }, [P]), c = (e = o, n = k.useRef(null), r = k.useCallback(function() {
      n.current === null && function g() {
        e(), n.current = B(g);
      }();
    }, [e]), a = k.useCallback(function() {
      N(n.current), n.current = null;
    }, []), k.useEffect(function() {
      n.current && (a(), r());
    }, [r, a]), k.useEffect(N, []), [r, a]), p = c[0], E = c[1];
    return k.useLayoutEffect(function() {
      if (t) {
        var g = s();
        return g.addEventListener("focus", p), g.addEventListener("blur", E), O(g) && p(), function() {
          g.removeEventListener("focus", p), g.removeEventListener("blur", E), E();
        };
      }
    }), { getSelection: P, getLastSelection: v, setSelection: u };
  }
  function ne(i, t) {
    var e = k.useRef(), n = ee(e, t), r = n.getSelection, a = n.getLastSelection, l = n.setSelection, s = function(o, c) {
      var p = M(o), E = k.useRef(c);
      return { getValue: k.useCallback(function() {
        return p().value;
      }, [p]), getLastValue: k.useCallback(function() {
        return E.current;
      }, []), setValue: k.useCallback(function(g) {
        E.current = g;
        var f = p();
        f && (f.value = g);
      }, [p]) };
    }(e, i), P = s.getValue, v = s.getLastValue, u = s.setValue;
    return { inputRef: e, getInputState: function() {
      return { value: P(), selection: r() };
    }, getLastInputState: function() {
      return { value: v(), selection: a() };
    }, setInputState: function(o) {
      var c = o.value, p = o.selection;
      u(c), l(p);
    } };
  }
  de();
  var te = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"], z = { 9: /[0-9]/, a: /[A-Za-z]/, "*": /[A-Za-z0-9]/ }, re = function(i) {
    var t = this;
    this.isCharacterAllowedAtPosition = function(e, n) {
      var r = t.maskOptions.maskPlaceholder;
      return !!t.isCharacterFillingPosition(e, n) || !!r && r[n] === e;
    }, this.isCharacterFillingPosition = function(e, n) {
      var r = t.maskOptions.mask;
      if (!e || n >= r.length)
        return !1;
      if (!t.isPositionEditable(n))
        return r[n] === e;
      var a = r[n];
      return new RegExp(a).test(e);
    }, this.isPositionEditable = function(e) {
      var n = t.maskOptions, r = n.mask, a = n.permanents;
      return e < r.length && a.indexOf(e) === -1;
    }, this.isValueEmpty = function(e) {
      return e.split("").every(function(n, r) {
        return !t.isPositionEditable(r) || !t.isCharacterFillingPosition(n, r);
      });
    }, this.isValueFilled = function(e) {
      return t.getFilledLength(e) === t.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function(e) {
      var n = t.getFilledLength(e), r = t.getRightEditablePosition(n);
      return { start: r, end: r };
    }, this.getFilledLength = function(e) {
      return function(n, r) {
        for (var a = n.length - 1; a >= 0; a--)
          if (r(n[a], a))
            return a;
        return -1;
      }(e.split(""), function(n, r) {
        return t.isPositionEditable(r) && t.isCharacterFillingPosition(n, r);
      }) + 1;
    }, this.getStringFillingLengthAtPosition = function(e, n) {
      return e.split("").reduce(function(r, a) {
        return t.insertCharacterAtPosition(r, a, r.length);
      }, function(r, a) {
        a === void 0 && (a = 1);
        for (var l = "", s = 0; s < a; s++)
          l += r;
        return l;
      }(" ", n)).length - n;
    }, this.getLeftEditablePosition = function(e) {
      for (var n = e; n >= 0; n--)
        if (t.isPositionEditable(n))
          return n;
      return null;
    }, this.getRightEditablePosition = function(e) {
      for (var n = t.maskOptions.mask, r = e; r < n.length; r++)
        if (t.isPositionEditable(r))
          return r;
      return null;
    }, this.formatValue = function(e) {
      var n = t.maskOptions, r = n.maskPlaceholder, a = n.mask;
      if (!r) {
        for (e = t.insertStringAtPosition("", e, 0); e.length < a.length && !t.isPositionEditable(e.length); )
          e += a[e.length];
        return e;
      }
      return t.insertStringAtPosition(r, e, 0);
    }, this.clearRange = function(e, n, r) {
      if (!r)
        return e;
      var a = n + r, l = t.maskOptions, s = l.maskPlaceholder, P = l.mask, v = e.split("").map(function(u, o) {
        var c = t.isPositionEditable(o);
        return !s && o >= a && !c ? "" : o < n || o >= a ? u : c ? s ? s[o] : "" : P[o];
      }).join("");
      return t.formatValue(v);
    }, this.insertCharacterAtPosition = function(e, n, r) {
      var a = t.maskOptions, l = a.mask, s = a.maskPlaceholder;
      if (r >= l.length)
        return e;
      var P = t.isCharacterAllowedAtPosition(n, r), v = t.isPositionEditable(r), u = t.getRightEditablePosition(r), o = s && u ? n === s[u] : null, c = e.slice(0, r);
      return !P && v || (e = c + (P ? n : l[r])), P || v || o || (e = t.insertCharacterAtPosition(e, n, r + 1)), e;
    }, this.insertStringAtPosition = function(e, n, r) {
      var a = t.maskOptions, l = a.mask, s = a.maskPlaceholder;
      if (!n || r >= l.length)
        return e;
      var P = n.split(""), v = t.isValueFilled(e) || !!s, u = e.slice(r);
      return e = P.reduce(function(o, c) {
        return t.insertCharacterAtPosition(o, c, o.length);
      }, e.slice(0, r)), v ? e += u.slice(e.length - r) : t.isValueFilled(e) ? e += l.slice(e.length).join("") : e = u.split("").filter(function(o, c) {
        return t.isPositionEditable(r + c);
      }).reduce(function(o, c) {
        var p = t.getRightEditablePosition(o.length);
        return p === null ? o : (t.isPositionEditable(o.length) || (o += l.slice(o.length, p).join("")), t.insertCharacterAtPosition(o, c, o.length));
      }, e), e;
    }, this.processChange = function(e, n) {
      var r = t.maskOptions, a = r.mask, l = r.prefix, s = r.lastEditablePosition, P = e.value, v = e.selection, u = n.value, o = n.selection, c = P, p = "", E = 0, g = 0, f = Math.min(o.start, v.start);
      return v.end > o.start ? (p = c.slice(o.start, v.end), g = (E = t.getStringFillingLengthAtPosition(p, f)) ? o.length : 0) : c.length < u.length && (g = u.length - c.length), c = u, g && (g === 1 && !o.length && (f = o.start === v.start ? t.getRightEditablePosition(v.start) : t.getLeftEditablePosition(v.start)), c = t.clearRange(c, f, g)), c = t.insertStringAtPosition(c, p, f), (f += E) >= a.length ? f = a.length : f < l.length && !E ? f = l.length : f >= l.length && f < s && E && (f = t.getRightEditablePosition(f)), { value: c = t.formatValue(c), enteredString: p, selection: { start: f, end: f } };
    }, this.maskOptions = function(e) {
      var n = e.mask, r = e.maskPlaceholder, a = [];
      if (!n)
        return { maskPlaceholder: null, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
      if (typeof n == "string") {
        var l = !1, s = "";
        n.split("").forEach(function(u) {
          l || u !== "\\" ? (!l && z[u] || a.push(s.length), s += u, l = !1) : l = !0;
        }), n = s.split("").map(function(u, o) {
          return a.indexOf(o) === -1 ? z[u] : u;
        });
      } else
        n.forEach(function(u, o) {
          typeof u == "string" && a.push(o);
        });
      r && (r = r.length === 1 ? n.map(function(u, o) {
        return a.indexOf(o) !== -1 ? u : r;
      }) : r.split(""), a.forEach(function(u) {
        r[u] = n[u];
      }), r = r.join(""));
      for (var P = a.filter(function(u, o) {
        return u === o;
      }).map(function(u) {
        return n[u];
      }).join(""), v = n.length - 1; a.indexOf(v) !== -1; )
        v--;
      return { maskPlaceholder: r, prefix: P, mask: n, lastEditablePosition: v, permanents: a };
    }(i);
  }, ie = function(i) {
    function t() {
      return i.apply(this, arguments) || this;
    }
    return K(t, i), t.prototype.render = function() {
      var e = this.props, n = e.children, r = I(e, ["children"]);
      return F.cloneElement(n, r);
    }, t;
  }(F.Component), x = k.forwardRef(function(i, t) {
    var e = i.alwaysShowMask, n = i.children, r = i.mask, a = i.maskPlaceholder, l = i.beforeMaskedStateChange, s = I(i, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    (function(h) {
      var d = h.mask, m = h.maskPlaceholder;
      d && m && m.length !== 1 && m.length !== d.length && q(!1);
    })(i);
    var P, v, u = new re({ mask: r, maskPlaceholder: a }), o = !!r, c = !s.disabled && !s.readOnly, p = i.value !== null && i.value !== void 0, E = (P = o, v = k.useRef(), k.useEffect(function() {
      v.current = P;
    }), v.current), g = ne(function(h) {
      return "" + h;
    }((p ? i.value : i.defaultValue) || ""), o), f = g.inputRef, S = g.getInputState, y = g.setInputState, w = g.getLastInputState, A = M(f);
    if (o && p) {
      var X = A(), _ = X && O(X) || e || i.value ? u.formatValue(i.value) : i.value;
      l && (_ = l({ nextState: { value: _, selection: { start: null, end: null } } }).value), y(V({}, w(), { value: _ }));
    }
    var Y = w(), ae = Y.selection, oe = Y.value;
    k.useLayoutEffect(function() {
      if (o) {
        var h = O(A()), d = ae, m = S(), b = V({}, m);
        if (!p) {
          var C = m.value, L = u.formatValue(C), R = u.isValueEmpty(L);
          !R || h || e ? b.value = L : R && !h && (b.value = "");
        }
        h && !E ? b.selection = u.getDefaultSelectionForValue(b.value) : p && h && d && d.start !== null && d.end !== null && (b.selection = d), l && (b = l({ currentState: m, nextState: b })), y(b);
      }
    });
    var Z = V({}, s, { onFocus: function(h) {
      f.current = h.target;
      var d = S().value;
      if (o && !u.isValueFilled(d)) {
        var m = u.formatValue(d), b = u.getDefaultSelectionForValue(m), C = { value: m, selection: b };
        l && (m = (C = l({ currentState: S(), nextState: C })).value, b = C.selection), y(C), m !== d && i.onChange && i.onChange(h), B(function() {
          y(w());
        });
      }
      i.onFocus && i.onFocus(h);
    }, onBlur: function(h) {
      var d = S().value, m = w().value;
      if (o && !e && u.isValueEmpty(m)) {
        var b = "", C = { value: b, selection: { start: null, end: null } };
        l && (b = (C = l({ currentState: S(), nextState: C })).value), y(C), b !== d && i.onChange && i.onChange(h);
      }
      i.onBlur && i.onBlur(h);
    }, onChange: o && c ? function(h) {
      var d = S(), m = w(), b = u.processChange(d, m);
      l && (b = l({ currentState: d, previousState: m, nextState: b })), y(b), i.onChange && i.onChange(h);
    } : i.onChange, onMouseDown: o && c ? function(h) {
      var d = A(), m = S().value, b = T(d);
      if (!O(d) && !u.isValueFilled(m)) {
        var C = h.clientX, L = h.clientY, R = new Date().getTime();
        b.addEventListener("mouseup", function ue($) {
          if (b.removeEventListener("mouseup", ue), O(d)) {
            var le = Math.abs($.clientX - C), se = Math.abs($.clientY - L), H = Math.max(le, se), U = new Date().getTime() - R;
            if (H <= 10 && U <= 200 || H <= 5 && U <= 300) {
              var W = w(), ce = V({}, W, { selection: u.getDefaultSelectionForValue(W.value) });
              y(ce);
            }
          }
        });
      }
      i.onMouseDown && i.onMouseDown(h);
    } : i.onMouseDown, ref: function(h) {
      f.current = J.findDOMNode(h), function(d) {
        return typeof d == "function";
      }(t) ? t(h) : t !== null && typeof t == "object" && (t.current = h);
    }, value: o && p ? oe : i.value });
    return n ? (function(h, d) {
      te.filter(function(m) {
        return d.props[m] != null && d.props[m] !== h[m];
      }).length && q(!1);
    }(i, n), F.createElement(ie, Z, n)) : F.createElement("input", Z);
  });
  return x.displayName = "InputMask", x.defaultProps = { alwaysShowMask: !1, maskPlaceholder: "_" }, D.exports = x, D.exports;
}
export {
  Se as __require
};
//# sourceMappingURL=react-input-mask.production.min.js.map
